import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Lock, LockOpen } from 'lucide-react';
import { API } from '../../App';

const label = (run) => new Date(run.year, run.month - 1, 1).toLocaleDateString('en-MY', { month: 'long', year: 'numeric' });

export const RunStateButtons = ({ run, onChanged }) => {
  const [busy, setBusy] = useState(false);

  const finalize = async () => {
    if (!window.confirm(`Finalize the ENTIRE payroll run for ${label(run)}? Every payslip in this month will be locked from edits.`)) return;
    setBusy(true);
    try {
      const res = await axios.put(`${API}/payroll/runs/${run.payroll_id}/finalize`);
      toast.success(`Finalized ${res.data?.finalized_payslips ?? 0} payslip(s)`);
      onChanged?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to finalize run');
    } finally {
      setBusy(false);
    }
  };

  const unfinalize = async () => {
    const reason = window.prompt(`Unfinalize payroll run for ${label(run)}?\nAll payslips become editable again. Enter a reason (min 5 characters):`);
    if (reason === null) return;
    if (reason.trim().length < 5) { toast.error('Reason must be at least 5 characters'); return; }
    setBusy(true);
    try {
      const res = await axios.post(`${API}/payroll/runs/${run.payroll_id}/unfinalize`, { reason: reason.trim() });
      toast.success(res.data?.message || 'Payroll run unfinalized');
      onChanged?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to unfinalize run');
    } finally {
      setBusy(false);
    }
  };

  if (run.finalized) {
    return (
      <button type="button" disabled={busy} onClick={unfinalize} data-testid={`unfinalize-run-${run.payroll_id}`}
        className="mt-3 w-full inline-flex items-center justify-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-md border border-amber-400 text-amber-800 hover:bg-amber-50 disabled:opacity-50 dark:border-amber-500 dark:text-amber-200 dark:hover:bg-amber-900/30">
        <LockOpen className="h-3.5 w-3.5" /> {busy ? 'Working…' : 'Unfinalize Run (allow edits)'}
      </button>
    );
  }
  return (
    <button type="button" disabled={busy} onClick={finalize} data-testid={`finalize-run-${run.payroll_id}`}
      className="mt-3 w-full inline-flex items-center justify-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-md bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-50">
      <Lock className="h-3.5 w-3.5" /> {busy ? 'Working…' : 'Finalize Run (lock payslips)'}
    </button>
  );
};
